import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { ZERO, TOP_LAYER, LAYER_ONE } from "constants/z-index";
import { SPACE_BLUE_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";

export const componentStyles = css.global`
  .universe-star-tag-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
    z-index: ${TOP_LAYER};
    cursor: pointer;

    .background-circle {
      transition: opacity 100ms ease-in-out;
      position: absolute;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: currentColor;
      opacity: 0%;
      filter: blur(30px);
      z-index: ${ZERO};
    }

    .star-image {
      .star-picture {
        display: flex;
        .star-icon {
          height: 40px;
        }
      }
    }
    .star-text {
      transition: opacity 100ms ease-in-out;
      text-align: center;
      max-width: 100px;
      font-size: 16px;
      color: ${Colors[WHITE_COLOR_NAME]};
      opacity: 75%;
      padding-top: 4px;
    }

    &.selected,
    &:hover {
      .background-circle {
        opacity: 40%;
      }
      .star-text {
        opacity: 100%;
        z-index: ${LAYER_ONE}
      }
    }

    &.selectable-cluster {
      justify-content: unset;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      margin: 8px;
      padding: 8px 8px 16px 8px;
      height: calc(100% - 16px);
      transition: all 0.2s ease-in-out;

      .checkbox {
        border: 1px solid rgba(255, 255, 255, 0.3);
        transition: all 0.2s ease-in-out;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        align-self: start;
        svg {
          path {
            fill: ${Colors[SPACE_BLUE_COLOR_NAME]};
          }
        }
      }

      &.selected,
      &:hover {
        transition: all 0.2s ease-in-out;
        border-color: currentColor;
        .background-circle {
          opacity: 0;
        }
        .checkbox {
          border-color: currentColor;
        }
      }

      &.selected {
        .checkbox {
          background-color: currentColor;
          svg {
            path {
              fill: ${Colors[SPACE_BLUE_COLOR_NAME]};
            }
          }
        }
      }
    }
  }
`;
